import React, { PureComponent } from 'react'
import { Form, TextArea, Grid, Button, Modal } from 'semantic-ui-react'
import firebase from 'firebase/app'

import utils from '../../utils'

export default class ModalEditNote extends PureComponent {
  state = {
    note: '',
    saving: false,
  }

  componentWillReceiveProps(nextProps) {
    const { order } = this.props

    if (nextProps.order && nextProps.order !== order) {
      this.setState({ note: nextProps.order.note })
    }
  }

  onModalClose = () => {
    const { onCancel } = this.props

    this.setState({ note: '', saving: false }, onCancel)
  }

  onNoteChange = e => this.setState({ note: e.target.value })

  handleOnSavingClick = async () => {
    try {
      const { order } = this.props
      const { note } = this.state
      const updates = {}

      this.setState({ saving: true })

      updates[`orders/${order.key}/note`] = note.trim() || ''

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.onModalClose()
    } catch (error) {
      alert(error.message || error)
      this.setState({ saving: false })
    }
  }

  render() {
    const { visible, order } = this.props
    const { saving, note } = this.state

    const orderNumber = (order && utils.order.getOrderNumber(order)) || '#######'

    return (
      <Modal
        open={visible}
        style={{ marginTop: 0, width: 600 }}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>Delivery Note {orderNumber}</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Grid columns="equal" style={{ margin: 0 }}>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column style={{ padding: 10 }}>
                <Form>
                  <TextArea
                    value={note}
                    style={{ minHeight: 200 }}
                    onChange={this.onNoteChange}
                    placeholder="Delivery note..."
                  />
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button negative disabled={saving} onClick={this.onModalClose}>
            Cancel
          </Button>
          <Button
            secondary
            content="Save"
            loading={saving}
            disabled={saving}
            onClick={this.handleOnSavingClick}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/ModalEditNote.js